<template>
    <div class="shapes">
        <div class="shapes__wrapper">
            <div class="shape_1"></div>
            <div class="shape_2"></div>
            <div class="shape_3"></div>
            <div class="shape_4"></div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .shapes {
        height: 200px;
        width: 330px;
        overflow: hidden;

        position: fixed;
        bottom: 0;
        right: 0;

        &__wrapper {
            width: 355px;
            height: 358px;

            .shape_1,
            .shape_2,
            .shape_3,
            .shape_4 {
                position: absolute;
                border-radius: 387px;
            }

            .shape_1 {
                top: 153px;
                left: 109px;
                width: 54px;
                height: 209px;

                background-color: var(--joy-color-tertiary-10);
                transform: rotate(42deg);
            }

            .shape_2 {
                top: 119px;
                left: 150px;
                width: 70px;
                height: 271px;

                background-color: var(--joy-color-tertiary-30);
                transform: rotate(32deg);
            }

            .shape_3 {
                top: 80px;
                left: 221px;
                width: 83px;
                height: 321px;

                background-color: var(--joy-color-tertiary-50);
                transform: rotate(7deg);
            }
            .shape_4 {
                top: 34px;
                left: 290px;
                width: 83px;
                height: 321px;

                background-color: var(--joy-color-tertiary-70);
                transform: rotate(-9deg);
            }
        }
    }
</style>
